// extracted by mini-css-extract-plugin
module.exports = {"extendedContentContainer":"ExtendedContentContainer_extendedContentContainer__2fFVr","contentView":"ExtendedContentContainer_contentView__1vT_D"};